import Chart from 'react-apexcharts';

interface IChart {
  pieChartNumbers: number[];
  pieChartLabels: string[];
  pieChartColor: string[];
}

function PieChart({ pieChartNumbers, pieChartLabels, pieChartColor }: IChart) {
  // Precompute the total so the tooltip can show `count (percent%)` and
  // users don't see a mix of percentages on slice labels and raw counts
  // in the hover tooltip. Guard against zero total (an all-empty pie
  // shouldn't render here anyway — the parent gates on convNumber —
  // but the formatter would produce NaN% otherwise).
  const total = pieChartNumbers.reduce((sum, n) => sum + (n || 0), 0);

  const options = {
    chart: {
      type: 'pie' as const,
      dropShadow: { enabled: false },
    },
    legend: {
      show: true,
      position: 'bottom' as const,
      fontSize: '13px',
      labels: { colors: '#525252' },
    },
    labels: pieChartLabels,
    colors: pieChartColor,
    dataLabels: {
      formatter: (val: number) => `${val.toFixed(1)}%`,
      dropShadow: { enabled: false },
      style: {
        fontSize: '12px',
        fontWeight: 500,
      },
    },
    stroke: {
      width: 1,
      colors: ['#fff'],
    },
    tooltip: {
      y: {
        // Show count + percent to match the slice label's unit. ApexCharts
        // passes the raw series value (count) here, not the percentage.
        formatter: (val: number) => {
          if (!total) return `${val}`;
          const pct = ((val / total) * 100).toFixed(1);
          return `${val} (${pct}%)`;
        },
      },
    },
  };

  const series = pieChartNumbers;

  return (
    <div className="w-full max-w-2xl">
      <Chart options={options} series={series} type="pie" width="100%" height="480" />
    </div>
  );
}

export default PieChart;
